const header = jQuery('.header'),
dropDownButton = jQuery('.header__dropdown-button');

// On click - Toggle Menu Drop-down #}
dropDownButton.click(toggleDropDownMenu);

// On scroll - Change Header State to Scrolled
jQuery(window).scroll(toggleHeaderState);


function toggleDropDownMenu() {
    const headerIsActive = header.hasClass('header--dropdown-active');

    if(headerIsActive) {
    header.removeClass('header--dropdown-active');
    return;
    }

    header.addClass('header--dropdown-active');
}

function toggleHeaderState() {
    if(window.scrollY || document.body.scrollTop > window.innerHeight) {
    header.addClass('header--scrolled');
    return;
    }

    header.removeClass('header--scrolled');
}